export default "__VITE_ASSET__D5Dxt8hj__"